import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import SMBImage from '@components/Image'

import { H2, H4, H6, Small } from '@components/Text'

export const Wrapper = styled.section`
  padding-top: 32px;
  padding-bottom: 8px;
  background-color: var(--white);

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-bottom: 48px;
  }
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 37px;
  color: var(--primary-text);

  span {
    color: var(--sao-paulo-60);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    line-height: 48px;
  }
`

export const ListWrapper = styled.section`
  margin-top: 56px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 96px;
  }
`

export const Item = styled.section`
  display: flex;
  align-items: flex-start;
  margin-bottom: 64px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-bottom: 50px;
  }
`

export const ItemIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: var(--sao-paulo-10);

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: -12px;
  }
`

export const ItemIconText = styled(H4)`
  font-weight: 600;
  color: var(--primary-text);
`

export const ItemDescription = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: 16px;

  a {
    cursor: pointer;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    align-items: flex-start;
  }
`

export const ItemTitle = styled(H4)`
  font-weight: 700;
  line-height: 20px;
`

export const ItemSubtitle = styled(H6)`
  font-weight: 400;
  line-height: 24px;
  margin-top: 8px;

  a {
    font-weight: 700;
    text-decoration: none;
    color: var(--buenos-aires-60);
  }

  span {
    font-weight: 700;
    color: var(--sao-paulo-60);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
  }
`

export const Figure = styled.figure`
  position: relative;
`

export const FigureCaption = styled.figcaption`
  position: absolute;
  bottom: 12px;
  right: 100px;
`

export const Image = styled(SMBImage)`
  height: 330px;
`

export const ImageDescription = styled(Small)`
  line-height: 24px;
`
